import React from "react";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";

const SendDocumentToAppModal = ({
  as: As = Button,
  document,
  submitAction,
  submitParams,
  sendDescription = "It will appear on the app the next time a sync is run.",
  stopDescription = "It will be removed from the app the next time a sync is run.",
  onUpdated,
  ...props
}) => {
  const sendToApp = !document.sendToApp;

  return (
    <ModalBuilder
      submitAction={submitAction}
      submitParams={{ ...submitParams, documentId: document.id, sendToApp }}
      onSubmitted={onUpdated}
      renderTrigger={(showModal) => <As onClick={showModal} {...props} />}
      renderModal={(modalProps) => (
        <Modal.Confirmation
          {...modalProps}
          header={sendToApp ? "Send to App" : "Do Not Send to App"}
        >
          {sendToApp
            ? `Are you sure you wish to send ${document.fileName} to the app? ${sendDescription}`
            : `Are you sure you wish to stop sending ${document.fileName} to the app? ${stopDescription}`}
        </Modal.Confirmation>
      )}
    />
  );
};

export default SendDocumentToAppModal;
